import classnames from 'classnames';
import noop from 'lodash/noop';
import { bool, func, node, oneOf } from 'prop-types';

import ComponentLoadingSection from 'shared/components/ComponentLoadingSection';

const BetBody = ({
  children,
  refHandler = noop,
  theme,
  isPaddingBottomView,
  hasCollaboration,
  loading = false,
}) => (
  <ComponentLoadingSection
    loading={loading}
    className={classnames('bet-body', {
      'bet-body--atg': theme === 'atg',
      'bet-body--sport': theme === 'sport',
      'bet-body--padding-bottom-view': isPaddingBottomView,
      'bet-body--with-collaboration': hasCollaboration,
    })}
    refHandler={refHandler}
  >
    {children}
  </ComponentLoadingSection>
);

BetBody.propTypes = {
  children: node.isRequired,
  refHandler: func,
  theme: oneOf(['atg', 'sport']).isRequired,
  isPaddingBottomView: bool,
  hasCollaboration: bool,
  loading: bool,
};

export default BetBody;
